/**
 * 要素をフェードインさせる関数
 * @param {HTMLElement} el - 対象のHTML要素
 * @param {number} [duration=300] - フェードインにかける時間（ミリ秒）
 * @param {object} [options={}] - オプション設定
 * @param {function} [options.onComplete] - フェードイン完了時に呼び出されるコールバック関数
 */
export const fadeIn = (el, duration = 300, options = {}) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;

  // 初期値を設定
  el.style.opacity = 0;
  el.offsetHeight; // リフロー強制

  // トランジションの設定
  el.style.transitionProperty = "opacity";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";

  // 透明度を1に設定
  el.style.opacity = 1;

  setTimeout(() => {
    // トランジション関連のプロパティをクリーンアップ
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");

    // コールバックが指定されていれば実行
    if (options.onComplete && typeof options.onComplete === "function") {
      options.onComplete();
    }
  }, duration);
};

/**
 * 要素をフェードアウトさせる関数
 * @param {HTMLElement} el - 対象のHTML要素
 * @param {number} [duration=300] - フェードアウトにかける時間（ミリ秒）
 * @param {object} [options={}] - オプション設定
 * @param {function} [options.onComplete] - フェードアウト完了時に呼び出されるコールバック関数
 */
export const fadeOut = (el, duration = 300, options = {}) => {
  // 現在の表示状態を保存
  let computedStyle = window.getComputedStyle(el);
  if (computedStyle.display === "none") return;

  // 透明度の初期化
  el.style.opacity = 1;

  // トランジションの設定
  el.style.transitionProperty = "opacity";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";

  // 透明度を0に設定
  el.style.opacity = 0;

  setTimeout(() => {
    el.style.display = "none";

    // トランジション関連のプロパティをクリーンアップ
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
    el.style.removeProperty("opacity");

    // コールバックが指定されていれば実行
    if (options.onComplete && typeof options.onComplete === "function") {
      options.onComplete();
    }
  }, duration);
};

/**
 * 要素のフェードインまたはフェードアウトを切り替える関数
 *
 * @param {HTMLElement} el - 対象のHTML要素
 * @param {number} [duration=300] - アニメーションの継続時間（ミリ秒）
 * @param {Object} [options={}] - オプション設定
 * @returns {void}
 */
export const fadeToggle = (el, duration = 300, options = {}) => {
  if (window.getComputedStyle(el).display === "none") {
    return fadeIn(el, duration, options);
  } else {
    return fadeOut(el, duration, options);
  }
};
